import React from 'react';
import { withRouter } from 'react-router';
import userStore from './stores/UserStore';

export function requireAuthentication(Component, role) {

	class AuthenticatedComponent extends React.Component {

		isAuthed = false;

		componentWillMount() {
			this.checkAuth();
		}

		componentWillReceiveProps() {
			this.checkAuth();
		}

		checkAuth() {

			if (role === 'none') return;

			let redirectAfterLogin = encodeURIComponent(this.props.location.pathname + this.props.location.search);
			if (userStore.user.user_id !== 0) {

				const userRole = userStore.user.role;

				if (role === 'any' || userRole === 'Admin') {
					this.isAuthed = true;
					return;
				}
				// didn't find one so go ahead and send over to the not authorized page
				this.props.router.replace('/unauthorized');

			} else {
				this.props.router.replace(`/login?next=${redirectAfterLogin}`);
			}

		}

		render() {
			if (this.isAuthed) {
				return (<Component {...this.props} />)
			} else {
				return (<div />)
			}
		}
	}

	return withRouter(AuthenticatedComponent);
};



/** WEBPACK FOOTER **
 ** ./src/AuthenticatedComponent.js
 **/